import config from '@/config'
import Listings from '@/models/Listings'
import BaseService from './BaseService'
import { requests } from './HTTPService'

const http = requests(config?.GOKOLLAB_SERVER_URL)

class ListingsServiceCls extends BaseService<Listings> {
  constructor() {
    super(null as any)
  }

  model() {
    return Listings
  }

  get endpoint(): string {
    return `/${config?.GOKOLLAB_LOCATION_ID}/listings`
  }

  async getListingsByExternalId(externalId: string) {
    const response = await http.get(`${this.endpoint}/${externalId}`)
    return response.data
  }

  async getListingCategoryByExternalId(externalId: string) {
    const response = await http.get(
      `${this.endpoint}/external-id/${externalId}/category`
    )
    return response.data
  }

  async refreshCategoryByExternalId(externalId: string) {
    const response = await http.post(
      `${this.endpoint}/external-id/${externalId}/refresh-category`
    )
    return response.data
  }

  async activateListingByExternalId(externalId: string, locationId: string) {
    const response = await http.post(`${this.endpoint}/activate`, {
      listings: [
        {
          type: 'Community',
          externalId,
          locationId,
        },
      ],
    })
    return response.data
  }

  async deactivateListingByExternalId(externalId: string) {
    const response = await http.post(`${this.endpoint}/deactivate`, {
      externalIds: [externalId],
    })
    return response.data
  }

  async updateSlugByExternalId(externalId: string, slug: string) {
    const response = await http.patch(
      `${this.endpoint}/external-id/${externalId}`,
      {
        slug,
      }
    )
    return response.data
  }
}

// Export singleton instance
export const ListingsService = new ListingsServiceCls()

// Export type for dependency injection
export type IListingsService = ListingsServiceCls

// Export commonly used methods directly
export const {
  getListingsByExternalId,
  activateListingByExternalId,
  deactivateListingByExternalId,
  updateSlugByExternalId,
} = ListingsService

export const useListingsService = () => {
  const getListingsByExternalId = async (externalId: string) => {
    return ListingsService.getListingsByExternalId(externalId)
  }

  const activateListingByExternalId = async (
    externalId: string,
    locationId: string
  ) => {
    return ListingsService.activateListingByExternalId(externalId, locationId)
  }

  const deactivateListingByExternalId = async (externalId: string) => {
    return ListingsService.deactivateListingByExternalId(externalId)
  }

  const updateSlugByExternalId = async (externalId: string, slug: string) => {
    return ListingsService.updateSlugByExternalId(externalId, slug)
  }

  return {
    getListingsByExternalId,
    activateListingByExternalId,
    deactivateListingByExternalId,
    updateSlugByExternalId,
  }
}
